import { render, staticRenderFns } from "./RequestsAnalysis.vue?vue&type=template&id=3db3bc8e"
import script from "./RequestsAnalysis.vue?vue&type=script&lang=js"
export * from "./RequestsAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports